"use client";

import { useState } from "react";
import Image from "next/image";
import { Modal } from "antd";
import qrImage from "@/assets/images/QRimage/AlfaMallAPPQR.png";
import { GET_APP_LABEL } from "./getOurAppConfig";
import "./GetOurApp.scss";

export default function GetOurAppButton() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        className="get-our-app-trigger"
        onClick={() => setOpen(true)}
      >
        {GET_APP_LABEL}
      </button>
      <Modal
        open={open}
        centered
        footer={null}
        width={520}
        onCancel={() => setOpen(false)}
        className="get-our-app-modal"
        // title={GET_APP_LABEL}
      >
        <Image
          src={qrImage}
          alt="Scan the QR and get the AlfaMall App"
          className="get-our-app-qr"
        />
      </Modal>
    </>
  );
}
